import type { ProbKey } from './keys';

export const nl: Partial<Record<ProbKey, string>> = {
  'app.eyebrow': 'Wiskunde · Kansrekening',
  'app.title': 'Kansrekening',
  'panel.experiment': 'Experiment',
  'panel.params': 'Parameters',
  'hint.line1': 'Kies een experiment, beweeg de schuifregelaars, kijk hoe de verdeling verandert.',
  'hint.line2': 'Leerstof leeft in de kansen, niet in de tekst.',
  'experiment.sample-space-lab.label': 'Uitkomstenruimte',
  'experiment.sample-space-lab.info': 'Verken uitkomstenruimten en bereken kansen',
  'experiment.conditional-bayes.label': 'Voorwaardelijk & Bayes',
  'experiment.conditional-bayes.info': 'Verken voorwaardelijke kans en stelling van Bayes',
  'experiment.random-variables.label': 'Stochasten',
  'experiment.named-distributions.label': 'Bekende verdelingen',
  'experiment.galton-board.label': 'Galton-plank',
  'experiment.sums-of-iid.label': 'Sommen van onafhankelijke stochasten',
  'experiment.normal-calculator.label': 'Normale verdeling',
  'experiment.classic-problems.label': 'Klassieke problemen',
  'submode.conditional-bayes.tree.label': 'Boom',
  'submode.conditional-bayes.flowchart.label': 'Stroomdiagram',
  'param.submode.label': 'Sub-modus',
  'param.preset.label': 'Voorinstelling',
  'param.prior.label': 'Voorafkans',
  'param.sensitivity.label': 'Gevoeligheid (ware positief)',
  'param.false-positive-rate.label': 'Onwaar positief',
  'param.show-formula-trace.label': 'Toon Bayes formule',
  'preset.conditional-bayes.medical-test.label': 'Medische test',
  'preset.conditional-bayes.spam-filter.label': 'Spam filter',
  'preset.conditional-bayes.monty-hall-as-bayes.label': 'Monty Hall als Bayes',
  'preset.conditional-bayes.draw-without-replacement.label': 'Trekken zonder terugleggen',
  'preset.conditional-bayes.coin-coin.label': 'Munt twee keer',
  'preset.conditional-bayes.custom-2level.label': 'Aangepast 2-niveau',
  'preset.conditional-bayes.custom-3level.label': 'Aangepast 3-niveau',
  'btn.reset-preset': 'Reset voorinstelling',
  'btn.step-animation': 'Stap animatie',
  'stat.prior': 'Vooraf',
  'stat.posterior': 'Achteraf',
  'stat.likelihood': 'Aannemelijkheid',
  'formula.bayes.statement': 'Stelling van Bayes',
  'message.siblings-sum-to-one': 'Kansen tellen op tot 1',
  'experiment.random-variables.info': 'Verken kansverdeling door steekproeven',
  'submode.random-variables.2d6-sum.label': 'Som van twee dobbelstenen',
  'submode.random-variables.2d6-diff.label': 'Absolute verschil van twee dobbelstenen',
  'submode.random-variables.2d6-max.label': 'Maximum van twee dobbelstenen',
  'submode.random-variables.coin-flips-count.label': 'Aantal koppen in 5 worpen',
  'btn.reset': 'Opnieuw instellen',
  'stat.expectation': 'E[X]',
  'stat.stdev': 'σ[X]',
  'stat.sample-count': 'Steekproeven',
  'experiment.named-distributions.info':
    'Verken binomiale, geometrische, Poisson en hypergeometrische verdelingen',
  'submode.named-distributions.binomial.label': 'Binomiaal',
  'submode.named-distributions.geometric.label': 'Geometrisch',
  'submode.named-distributions.poisson.label': 'Poisson',
  'submode.named-distributions.hypergeometric.label': 'Hypergeometrisch',
  'param.n.label': 'Aantal pogingen (n)',
  'param.p.label': 'Waarschijnlijkheid (p)',
  'param.lambda.label': 'Tarief (λ)',
  'param.N-population.label': 'Populatiegrootte (N)',
  'param.K-successes.label': 'Aantal successen (K)',
  'param.show-cdf.label': 'Toon CDF',
  'param.show-moments.label': 'Toon gemiddelde en ±σ',
  'param.show-pascal-row.label': 'Toon rij van de driehoek van Pascal',
  'param.compare-to.label': 'Vergelijk met...',
  'experiment.galton-board.info':
    'Simuleer balletjes die vallen door een Galton-plank om binomiale verdeling te verkennen',
  'param.rows.label': 'Aantal rijen',
  'param.show-binomial-theoretical.label': 'Toon theoretische binomium',
  'param.show-normal-approx.label': 'Toon normale benadering',
  'param.show-continuity-bins.label': 'Toon continuïteitscorrectie',
  'param.speed.label': 'Snelheid auto-drop',
  'btn.drop-one': 'Drop 1',
  'btn.drop-100': 'Drop 100',
  'btn.drop-1000': 'Drop 1000',
  'btn.auto-drop': 'Auto-drop',
  'experiment.sums-of-iid.info':
    'Verken de som en het gemiddelde van onafhankelijke, gelijkvormig verdeelde stochastische variabelen',
  'submode.sums-of-iid.uniform.label': 'Uniform [-1,1]',
  'submode.sums-of-iid.exponential.label': 'Exponentieel (λ=1)',
  'submode.sums-of-iid.bimodal.label': 'Bimodaal',
  'submode.sums-of-iid.discrete-die.label': 'Discrete dobbelsteen',
  'submode.sums-of-iid.custom-3-point.label': 'Aangepast 3-punt',
  'param.base-dist.label': 'Basisverdeling',
  'param.somregel.label': 'Toon somregel formules',
  'param.standardize.label': 'Standaardiseren',
  'param.sum-or-mean.label': 'Som of gemiddelde',
  'formula.somregel.mu': 'μ_S = n·μ',
  'formula.somregel.sigma-squared': 'σ²_S = n·σ²',
  'formula.somregel.sigma': 'σ_S = σ·√n',
  'btn.draw-100': 'Teken 100',
  'btn.draw-1000': 'Teken 1000',
  'btn.draw-10000': 'Teken 10000',
  'btn.auto-draw': 'Auto-teken',
  'experiment.normal-calculator.info': 'Verken de normale verdeling en continuïteitscorrectie',
  'submode.normal-calculator.density.label': 'Dichtheid',
  'submode.normal-calculator.bin-approx.label': 'Binomiale benadering',
  'param.region-type.label': 'Type regio',
  'param.mu.label': 'Gemiddelde (μ)',
  'param.sigma.label': 'Standaarddeviatie (σ)',
  'param.a-bound.label': 'Ondergrens (a)',
  'param.b-bound.label': 'Bovengrens (b)',
  'param.show-z-scores.label': 'Toon Z-scores',
  'param.show-68-95-99.label': 'Toon 68-95-99,7 banden',
  'param.show-continuity-correction.label': 'Toon continuïteitscorrectie',
  'region.between.label': 'Tussen (a ≤ X ≤ b)',
  'region.leq.label': 'Kleiner dan of gelijk (X ≤ a)',
  'region.geq.label': 'Groter dan of gelijk (X ≥ a)',
  'region.tails.label': 'Staarten (|X| ≥ a)',
  'experiment.classic-problems.info':
    'Verken het Monty Hall probleem, verjaardagparadox en Buffon-naald',
  'submode.classic-problems.monty-hall.label': 'Monty Hall probleem',
  'submode.classic-problems.birthday.label': 'Verjaardagparadox',
  'submode.classic-problems.buffon.label': 'Buffon-naald',
  'param.strategy.label': 'Strategie',
  'param.class-size.label': 'Klasgrootte (n)',
  'param.needle-length.label': 'Naaldengte (ℓ)',
  'param.show-formula.label': 'Toon formule',
  'strategy.switch.label': 'Wisselen',
  'strategy.stay.label': 'Blijven',
  'strategy.random.label': 'Willekeurig',
  'btn.play-1': 'Speel 1',
  'btn.play-100': 'Speel 100',
  'btn.play-10000': 'Speel 10000',
  'stat.win-rate.switch': 'Winrate wisselen',
  'stat.win-rate.stay': 'Winrate blijven',
  'stat.empirical-prob': 'Empirische P',
  'stat.theoretical-prob': 'Theoretische P',
  'stat.pi-estimate': 'π-schatting',
  'axis.outcome': 'Uitkomst',
  'axis.probability': 'Kans',
  'axis.probability-cumulative': 'Cumulatieve kans',
  'axis.value': 'Waarde',
  'axis.density': 'Dichtheid',
  'axis.count-bin': 'Bak',
  'axis.count': 'Aantal',
  'venn.set.A': 'A',
  'venn.set.B': 'B',
  'venn.set.C': 'C',
  'param.intersection.label': 'Doorsnedegrootte',
  'spinner.legend.sector': 'Sector',
};
